<template>
  <div class="map-pc">
    <!-- <div class="amap-wrapper" style="width:100%; height: 40vh">
      <iframe style="width: 100%;height: 100%;" :src="src" frameborder="no" framespacing="0" scrolling="no" allow="autoplay; encrypted-media" allowfullscreen="true"></iframe>
    </div> -->
    <!-- <div class="btn-area">
      <van-cell @click="show = true" title="地图队伍筛选" is-link :value="current" />
    </div> -->
    <div class="arrive_list"  :style="{'background-color': color}">
      <div class="head">
        <img :src="headerImg" />
      </div>
      <div class="body">
        <div v-for="(group, index) in l_time_list" :key="index" class="item" :style="{'color': color}">
          {{ group.info.numberid1 }}
          <!-- <div class="info">
            <div class="g-name">{{ group.groupname }}</div>
            <div class="g-num">{{ group.ename }}</div>
          </div>
          <div class="l-time">{{ group.info.numberid1 }}</div> -->
        </div>
      </div>
      <div class="footer">*以上信息仅供参考，以现场实际信息为准</div>
    </div>
    <!-- <van-popup position="bottom" v-model="show">
      <van-picker show-toolbar title="筛选队伍" :columns="t_list" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup> -->
  </div>
</template>

<script>
import { getNewData } from '@/libs/api.js'

export default {
  filters: {
    time(val) {
      if (!val) return '--分--秒'
      val = new Date(val)
      let h = val.getHours()
      let m = val.getMinutes()
      if (isNaN(h) || isNaN(m)) {
        return '--分--秒'
      }
      return h + '时' + m + '分'
    },
  },
  data() {
    return {
      src: 'https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=1977218188&quality=0',
      player: null,
      l_time_list: [],
      loading: false,
      color: '#c5141e',
      headerImg: 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head.png'
    }
  },
  mounted() {
    let group = this.$route.query.group
    if (group == 'A') { 
      this.color = '#0065AC' 
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head1.png'
    } else if (group == 'B') { 
      this.color = '#7D4697'
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head2.png'
    } else if (group == 'C') { 
      this.color = '#F5AC3C'
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head3.png'
    }
    let self = this
    this.getList()
    setInterval(() => {
      if (self.loading) {
        return
      }
      self.getList()
    }, 5000)
  },
  
  methods: {
    getList() {
      this.loading = true
      let group = this.$route.query.group
      getNewData(this.$route.query).then(res=>{
        if(res.status == 200) {
          let arr = []
          res.data.forEach(item=>{
            if(group && item.info.numberid1.indexOf(group) !== -1) {
              item.info.numberid1 = this.formatId(item.info.numberid1)
              arr.push(item)
            } else if(!group) {
              item.info.numberid1 = this.formatId(item.info.numberid1)
              arr.push(item)
            }
            
          })
          this.l_time_list = arr
        }
        this.loading = false
      })
    },
    formatId(id) {
      if (id.length < 3) return id; // 防止过短
      const prefix = id.slice(0, -2);
      const suffix = id.slice(-2);
      return `${prefix}-${suffix}`;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style lang="less" scoped>
.map-pc {
  
  .arrive_list {
    border-top: 1px solid #eee;
    height: 100vh;
    // background-color: #c5141e;
    position: relative;
    // padding-bottom: 100px;
    .head {
      margin-bottom: 30px;
      img {
        width: 100%;
      }
    }
    .body {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px;
      .item {
        width: 30%;
        background: #fff;
        border-radius: 6px;
        // padding: 15px;
        font-size: 24px;
        text-align: center;
        margin-bottom: 16px;
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10px 0;
      text-align: center;
      background: transparent;
      color: #fff;
      box-shadow: none;
      font-size: 12px;
    }
  }
}
</style>
